/**
 * Homepage selectors
 */


import { createSelector } from '@reduxjs/toolkit';

import { initialState } from './slice';
import { RootState } from 'types/RootState';

// TODO: Add an explanation for this
const selectDomain = (state: RootState) => state.customersSelectState || initialState;

export const selectCustomers = createSelector(
  [selectDomain],
  cityState => cityState.customers,
);

export const selectPagination = createSelector(
    [selectDomain],
    cityState => cityState.pagination,
);

export const selectIsLoading = createSelector(
    [selectDomain],
    cityState => cityState.isLoading,
);
